/**
 * FOOTRA 3D Model Viewer Controller
 * Interactivity, camera angles, and annotations
 */

document.addEventListener('DOMContentLoaded', () => {
  const modelViewer = document.querySelector('#footra-model-viewer');
  if (!modelViewer) return;

  const presetButtons = document.querySelectorAll('[data-camera-preset]');
  presetButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      presetButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const orbit = btn.getAttribute('data-camera-preset');
      if (orbit) {
        modelViewer.cameraOrbit = orbit;
      }
    });
  });

  const rotateToggle = document.querySelector('[data-toggle-rotate]');
  if (rotateToggle) {
    rotateToggle.addEventListener('click', () => {
      const isRotating = modelViewer.hasAttribute('auto-rotate');
      if (isRotating) {
        modelViewer.removeAttribute('auto-rotate');
        rotateToggle.classList.remove('active');
        rotateToggle.textContent = 'Auto-Rotate: Off';
      } else {
        modelViewer.setAttribute('auto-rotate', '');
        rotateToggle.classList.add('active');
        rotateToggle.textContent = 'Auto-Rotate: On';
      }
    });
  }
});
